import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";

const LEGEND_DOT_SX = { width: 8, height: 8, borderRadius: "50%" };

export function IngestionLegend({ strings }) {
  return (
    <Paper
      elevation={2}
      sx={{
        py: 1,
        px: 1.5,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: 140,
        flexShrink: 0,
      }}
    >
      <Typography
        variant="overline"
        sx={{
          fontWeight: "bold",
          mb: 0.5,
          display: "block",
          fontSize: "0.6rem",
        }}
      >
        {strings.legend}
      </Typography>
      <List sx={{ p: 0 }}>
        <ListItem sx={{ p: 0 }}>
          <ListItemIcon sx={{ minWidth: 20 }}>
            <Box sx={{ ...LEGEND_DOT_SX, bgcolor: "success.main" }} />
          </ListItemIcon>
          <ListItemText
            primary={strings.finished}
            primaryTypographyProps={{ variant: "caption", fontWeight: 500 }}
            sx={{ my: 0.1 }}
          />
        </ListItem>
        <ListItem sx={{ p: 0 }}>
          <ListItemIcon sx={{ minWidth: 20 }}>
            <Box sx={{ ...LEGEND_DOT_SX, bgcolor: "warning.light" }} />
          </ListItemIcon>
          <ListItemText
            primary={strings.inProgress}
            primaryTypographyProps={{ variant: "caption", fontWeight: 500 }}
            sx={{ my: 0.1, whiteSpace: "nowrap" }}
          />
        </ListItem>
        <ListItem sx={{ p: 0 }}>
          <ListItemIcon sx={{ minWidth: 20 }}>
            <Box sx={{ ...LEGEND_DOT_SX, bgcolor: "error.main" }} />
          </ListItemIcon>
          <ListItemText
            primary={strings.error}
            primaryTypographyProps={{ variant: "caption", fontWeight: 500 }}
            sx={{ my: 0.1 }}
          />
        </ListItem>
      </List>
    </Paper>
  );
}
